import React from 'react';
import { useTranslation } from 'react-i18next';

import { useToastError } from 'lib/hooks';

import { ChooseRecordingOptions } from 'app/pages/recordv1/ChooseRecordingOptions';
import { LoadingIndicator } from 'lib/components';
import { Button } from 'react-covideo-common';
import { MdClose } from 'react-icons/md';
import { useVoiceOverSignUrlWithAudioUpload } from './useVoiceOverSignUrlWithAudioUpload';
import { RecordSettingsProvider } from 'lib/context/record/provider';
import { ISourceType } from 'lib/components/modal/mergeModal/types';
import { FullScreenModal } from 'lib/components/FullScreenModal';

type Props = {
  handleAddExternalVideo: (
    uploadedUrl: string,
    source?: ISourceType,
    previewUrl?: string
  ) => void;
  onModalCloseHandler: () => void;
};

export const AddRecordingToMerge = ({
  handleAddExternalVideo,
  onModalCloseHandler,
}: Props) => {
  const { t } = useTranslation();
  const { showError } = useToastError();

  const { startUpoladingVoiceover, isLoading } =
    useVoiceOverSignUrlWithAudioUpload();

  const onStartUpladingVoiceOverHandler = async (blob: Blob) => {
    try {
      const response = await startUpoladingVoiceover(blob);
      handleAddExternalVideo(response.downloadUrl, undefined, response.url);
    } catch (error) {
      showError(error);
      onModalCloseHandler();
    }
  };

  if (isLoading) {
    return (
      <FullScreenModal>
        <div>
          <LoadingIndicator isLoading={true} />
        </div>
      </FullScreenModal>
    );
  }

  return (
    <FullScreenModal
      headerLeft={
        <Button
          text={t('Close')}
          icon={<MdClose size='18' />}
          onClick={onModalCloseHandler}
          variant='transparent'
        />
      }
    >
      <RecordSettingsProvider>
        <ChooseRecordingOptions
          showHelpDesk={false}
          showPreview={false}
          onStartUpladingVoiceOverHandler={onStartUpladingVoiceOverHandler}
          extendStyles={{
            showRecorderWrapper: {
              padding: 32,
            },
          }}
        />
      </RecordSettingsProvider>
    </FullScreenModal>
  );
};
